import round from "../../../utils/round";
import linearInterpolation from "./linear-interpolation";

/**
 * Get progress
 * @param {PropertyValueProps} property
 * @param {Number} percents
 * @returns
 */
const getProgressCoordinates = (property, percents) => {
  const oDuration = /** @type {Number} */ (property.get("o_duration"));
  const duration = oDuration === -1 ? 155 : oDuration;
  const previous = property.get("progress") || 0;
  const progress = linearInterpolation(previous || 0, percents, 155 / duration);
  const array = /** @type {Array<Number>} */ (property.get("last-progress-array"));

  array.push(progress);

  property.set("last-progress-array", array.slice(-3));
  property.set("progress", round(progress));

  return progress;
};

export default getProgressCoordinates;
